import { useCallback, useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';

import * as Actions from 'flex/Actions';
import { useAppSelector } from 'flex/utils';
import { TENANT_SETTING } from 'constants/GlobalConfig';

type TenantSettingsState = {
    isLoading: boolean;
    payload: any;
};

export const useCreateAdminUserManagement = () => {
    const [state, setState] = useState<TenantSettingsState>({
        isLoading: false,
        payload: null,
    });

    const tenantSettingControlCreateConnection = useAppSelector(
        (state) => state.tenantSettingControlCreateConnection,
    );

    const dispatch = useDispatch();

    useEffect(() => {
        const { meta, payload } = tenantSettingControlCreateConnection;

        // 通信中でない === 画面遷移など意図しないタイミング
        if (!state.isLoading) return;

        switch (meta.status) {
            case Actions.statusEnum.SUCCESS: {
                setState((state) => ({
                    ...state,
                    isLoading: false,
                    payload,
                }));
                return;
            }
            case Actions.statusEnum.FAILURE:
            case Actions.statusEnum.ERROR: {
                setState((state) => ({
                    ...state,
                    isLoading: false,
                }));
                return;
            }
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [tenantSettingControlCreateConnection]);

    const request = useCallback(
        (isEnabled: boolean) => {
            dispatch(
                Actions.http.connection.tenantSetting.controlCreate({
                    is_enabled: isEnabled,
                    name: TENANT_SETTING.SETTING_NAME_ADMIN_USER_MANAGEMENT,
                }),
            );

            setState((state) => ({
                ...state,
                isLoading: true,
            }));
        },
        [dispatch],
    );

    const reset = useCallback(() => {
        setState((state) => ({
            ...state,
            isLoading: false,
        }));
    }, []);

    return [state, request, reset] as const;
};
